import React from 'react';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';

import Logo from 'src/components/logo';
import { UI } from '../constants';

export default function FinalCta() {
  return (
    <Container maxWidth="md" sx={{ py: { xs: 8, md: 11 }, textAlign: 'center' }}>
      <Box sx={{ display: 'inline-flex', mb: 3 }}>
        <Logo width={44} />
      </Box>
      <Typography
        sx={{
          fontSize: { xs: '1.9rem', md: '2.6rem' },
          fontWeight: 800,
          letterSpacing: '-0.03em',
          color: UI.text,
        }}
      >
        Move the money. Skip the middle.
      </Typography>
      <Typography sx={{ mt: 1.5, color: UI.textMuted, maxWidth: 440, mx: 'auto' }}>
        Start with any amount — see the payout before you send a thing.
      </Typography>
      <Button
        component="a"
        href="#transfer"
        sx={{
          mt: 3.5,
          height: 48,
          px: 3.5,
          borderRadius: 6,
          fontWeight: 800,
          textTransform: 'none',
          color: '#0A0B08',
          background: UI.gradient,
          '&:hover': { background: UI.gradient, filter: 'brightness(1.05)' },
        }}
      >
        Start a transfer
      </Button>
    </Container>
  );
}
